export const VerifyIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      stroke="currentColor"
      className={className}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.587 8l1.607 1.613 3.22-3.226"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.167 1.633c.46-.393 1.213-.393 1.68 0L9.9 2.54c.2.173.574.313.84.313h1.134c.706 0 1.286.58 1.286 1.287v1.133c0 .26.14.64.314.84l.906 1.053c.394.46.394 1.214 0 1.68L13.474 9.9c-.174.2-.314.573-.314.84v1.133c0 .707-.58 1.287-1.286 1.287H10.74c-.26 0-.64.14-.84.313l-1.053.907c-.46.393-1.213.393-1.68 0l-1.053-.907a1.478 1.478 0 00-.84-.313H4.12c-.706 0-1.286-.58-1.286-1.287v-1.14c0-.26-.14-.633-.307-.833l-.9-1.06c-.387-.46-.387-1.207 0-1.667l.9-1.06c.167-.2.307-.573.307-.833V4.133c0-.707.58-1.287 1.286-1.287h1.154c.26 0 .64-.14.84-.313l1.053-.9z"
      ></path>
    </svg>
  )
}
